export default class UnauthorizedDomainError extends Error {
  constructor() {
    super("App domain is not authorized.");
  }
}
